/* eslint-disable */

import { Container, Row } from "react-bootstrap";
import { useReport } from "../ReportContext";
import SectionIntroduction from "../components/SectionIntroduction";
import NextPrevLinks from "../../components/NextPrevLinks";

const EmpathyAccuracy = () => {
	const { reportContent: { acf: { empathy_accuracy } } } = useReport();
	return (
		<div className="report-view">
			<SectionIntroduction text={empathy_accuracy.introduction} />
			<hr />
			<h2>Information about your Empathy Accuracy</h2>
			<Container className="bg-white d-flex flex-column gap-3 rounded-3 my-4">
				<p>Chart here</p>
			</Container>
			<h3>Your Empathy Accuracy is at the <span className="text-rating" style={{color: "var(--bs-danger)"}}>"Low"</span> Level</h3>
			<p>Rating-specific content here...</p>
			<hr />
						
			<NextPrevLinks />
		</div>
	);
};

export default EmpathyAccuracy;
